import React from 'react'
import { styled } from '@mui/material'

const StyledContainer = styled('div')(({ color, styles, theme }) => ({
    width: '100%',
    textAlign: 'center',
    backgroundColor: color ? color : theme?.palette?.background?.default,
    position: 'fixed',
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    ...styles,
}))

const StickyContainer = ({ children, ...rest }) => {
    return <StyledContainer {...rest}>{children}</StyledContainer>
}

export default StickyContainer
